<template>
  <div>
    <vxe-grid
      ref="vxeGrid"
      auto-resize
      highlight-hover-row
      :data="tableData"
      :toolbar-config="tableToolbar"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight - 6"
      size="small"
      resizable
      border
      :expand-config="{ reserve: true }"
      show-footer
      :footer-method="() => footerData"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:expandContent="{ row }">
        <OrderGoodsSpec
          :disabled="disabled"
          :orderGoodsCode="row.orderGoodsCode"
          :orderCode="row.orderCode"
          :tcOrderCode="row.tcOrderCode"
          :showDefaultImage="row.isGroup === 'Y'"
          class="m-2"
        />
      </template>
      <template v-slot:isGroup="{ row }">
        <el-tag size="mini" :type="row.isGroup === 'Y' ? 'light' : 'info'">
          {{ row.v_isGroup }}
        </el-tag>
      </template>
      <template v-slot:defaultImageUrl="{ row }">
        <el-image
          :src="
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic.jpg'
          "
          style="width:100px; height:66px"
          :preview-src-list="[
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic.jpg',
          ]"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 100px; height: 66px"
            />
          </div>
        </el-image>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="
                $emit('openEditFormDialog', {
                  type: 'detail',
                  code: row.tcOrderGoodsCode,
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
            v-if="!disabled"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="
                $emit('openEditFormDialog', {
                  type: 'edit',
                  code: row.tcOrderGoodsCode,
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="'查看图片'"
            placement="top"
          >
            <i
              class="el-icon-picture-outline tool-btn"
              @click="$emit('openImageDialog', row)"
            ></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-2">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import OrderGoodsSpec from '../../../order-goods-spec'
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import { add } from '@/libs/util.number.js'
export default {
  mixins: [TableAutoHeight],
  components: { OrderGoodsSpec },
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  computed: {
    footerData() {
      if (!this.tableData || !this.tableData.length) return []

      const {
        totalGoodsQty,
        totalBoxQty,
        totalTcPriceAmount,
        totalSubAmount,
      } = this.tableData.reduce(
        (result, next) => {
          result['totalGoodsQty'] = add(result['totalGoodsQty'], next['qty'])
          result['totalBoxQty'] = add(result['totalBoxQty'], next['boxQty'])
          result['totalTcPriceAmount'] = add(
            result['totalTcPriceAmount'],
            next['tcPriceAmount']
          )
          result['totalSubAmount'] = add(
            result['totalSubAmount'],
            next['subAmount']
          )
          return result
        },
        {
          totalGoodsQty: 0,
          totalBoxQty: 0,
          totalTcPriceAmount: 0,
          totalSubAmount: 0,
        }
      )

      return [
        [
          '合计',
          '',
          '',
          '',
          '',
          '',
          '',
          totalGoodsQty,
          '',
          '',
          totalBoxQty,
          '',
          totalTcPriceAmount.toLocaleString(),
          '',
          totalSubAmount.toLocaleString(),
        ],
      ]
    },
  },
}
</script>
